/*
 * @Author: zwt.daffy
 * @Date: 2019-08-05 10:03:05
 * @Last Modified by: zwt.daffy
 * @Last Modified time: 2019-09-20 14:58:23
 * 升级管理接口
 */
import request from '@/api/base'

// Version
const queryVersionList = (params) => {
  return request.post('/ipark-admin/upgrade/version/queryClientVersion', params)
}

const saveVersion = (params) => {
  return request.post('/ipark-admin/upgrade/version/saveClientVersion', params)
}

const delVersion = (params) => {
  return request.post('/ipark-admin/upgrade/version/delClientVersion', params)
}

// Gray User
const queryGrayUserList = (params) => {
  return request.post('/ipark-admin/upgrade/grayuser/queryGrayUserByCondition', params)
}

const downloadTemplate = (params) => {
  return request.get('/ipark-admin/upgrade/grayuser/downloadTemplate', { responseType: 'blob' }, params)
}

const downloadImportResult = (params) => {
  return request.get('/ipark-admin/upgrade/grayuser/downloadImportResult', { responseType: 'blob' }, params)
}

const exportGrayUser = (params) => {
  return request.get('/ipark-admin/upgrade/grayuser/exportGrayUserList', { responseType: 'blob' }, params)
}

const addGrayUser = (params) => {
  return request.post('/ipark-admin/upgrade/grayuser/addGrayUser', params)
}

const checkGrayUser = (params) => {
  return request.post('/ipark-admin/upgrade/grayuser/isGrayUserExist', params)
}

const deleteGrayUser = (params) => {
  return request.post('/ipark-admin/upgrade/grayuser/delGrayUserById', params)
}

export default {
  queryVersionList,
  saveVersion,
  delVersion,
  queryGrayUserList,
  downloadTemplate,
  downloadImportResult,
  exportGrayUser,
  addGrayUser,
  checkGrayUser,
  deleteGrayUser
}



// WEBPACK FOOTER //
// ./src/area-common/api/upgradeService.js